<h1>Neues in Version 2.3</h1>
<section class="article">
    <article>
        <h2>Import aus bestehenden Projekten</h2>
        <div class="text">
            <p>
                Version 2.3 ermöglicht den selektiven Import von Clips, Sequenzen 
                und Menüs aus bestehenden Projekten in das aktuelle Dokument. 
                Dazu hat video2manual einen neuen Menüpunkt bekommen.
            </p>
            <img src="assets/import_menu.png" style="width: 600px;" />
            <p>
                Nach der Auswahl des Quell-Projekts wird der Strukturbaum angezeigt. 
                Hier können beliebige Elemente für den Import ausgewählt werden.
            </p>
            <img src="assets/import_struct.png" style="width: 600px;" />
            <p>
                Haben Quell- und Zielprojekt unterschiedliche Auflösungen oder Seitenverhältnisse, 
                wird eine entsprechende Warnung ausgegeben. Ist die Auflösung des Quell-Projekts 
                kleiner als die Auflösung des aktuellen Projekts, müssen die Videos auf die 
                größere Auflösung hochgerechnet werden. Dadurch kann es zu Qualitätseinbußen kommen. 
                Ist das Seitenverhältnis des Quellprojekts anders als das Seitenverhältnis des 
                Zielprojekts (z.&nbsp;B. 16:9 und 4:3), erhalten die Videos automatisch 
                schwarze Balken an beiden Seiten bzw. oben und unten.
            </p>
            <p>
                Die gewählten Clips, Sequenzen und Menüs werden am Ende des aktuellen Projekts 
                eingefügt. Sie können jetzt einfach durch Verschieben mit der Maus an die 
                gewünschte Stelle gebracht werden.
            </p>
            <p>
                Die neue Funktion ermöglicht es jetzt z.&nbsp;B. auch, Projekte als Vorlagen mit 
                Standard-Elementen zu erstellen und die wiederkehrenden Elemente jeweils 
                aus diesen Vorlagen zu importieren.
            </p>
        </div>
    </article>
</section>
<section class="article">
    <article>
        <h2>Bildgenaue Navigation in der Zeitleiste</h2>
        <div class="text">
            <p>
                Insbesondere bei längeren Clips ist die genaue Positionierung auf ein bestimmtes
                Bild mit der Maus schwierig. Zu diesem Zweck musste man bisher in die Zeitleiste
                hineinzoomen, um die einzelnen Bilder ansteuern zu können. 
                Version 2.3 hat zu diesem Zweck neue Schaltflächen und Tastaturkürzel bekommen.
            </p>
            <img src="assets/navigation_tools.png" style="width: 600px;" />
            <table style="width: 100%; margin-top: 20px;">
                <tr>
                    <th>Schaltfläche</th>
                    <th>Funktion</th>
                    <th>Tastaturkürzel</th>
                </tr>
                <tr>
                    <td><img src="assets/one_step_left.png" /></td>
                    <td>Cursor ein Bild nach links navigieren</td>
                    <td>Strg + Umschalt + Links</td>
                </tr>
                <tr>
                    <td><img src="assets/one_step_right.png" /></td>
                    <td>Cursor ein Bild nach rechts navigieren</td>
                    <td>Strg + Umschalt + Rechts</td>
                </tr>
                <tr>
                    <td><img src="assets/set_clip_start.png" /></td>
                    <td>Startposition des Clips setzen</td>
                    <td>Strg + Umschalt + Pos1</td>
                </tr>
                <tr>
                    <td><img src="assets/set_clip_end.png" /></td>
                    <td>Endposition des Clips setzen</td>
                    <td>Strg + Umschalt + Ende</td>
                </tr>
            </table>
            <p>
            </p>
        </div>
    </article>
</section>
<section class="article">
    <article>
        <h2>JavaScript als Element-Aktion</h2>
        <div class="text">
            <p>
                Version 2.3 ergänzt die Möglichkeiten, auf Benutzereingaben zu reagieren,
                um den Aufruf von eigenen JavaScripten. Das ermöglicht insbesondere die
                Kommunikation mit externen Webdiensten.
            </p>
            <img src="assets/script_editor.png" />
        </div>
    </article>
</section>